import { stockApi } from '$api'
import { Brand } from '$models'
import { getActiveCompanySettings } from '$utils'

/**
 * Retrieves all brands
 * @returns an list of brands
 */
export const getAllBrands = async (): Promise<Brand[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return await stockApi.getBrands()
}
